module.exports = __webpack_public_path__ + "static/melissa-seidemann-portrait-12abeb6fdae09782dd132415930263c3.jpg";